module.exports = __webpack_public_path__ + "img/img-11.45eecebb.png";